import { render, staticRenderFns } from "./assignStudyGroup.vue?vue&type=template&id=d7cc6722&"
import script from "./assignStudyGroup.vue?vue&type=script&lang=js&"
export * from "./assignStudyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports